export default __webpack_public_path__ + "static/AeonikLight-cb84260fcd613248e1815593dbac4ed8.otf";